<template>
  <!-- 横屏 -->
  <horizontalScreen class="v-game-course"> 
    <!-- <scaleWrap> -->
      <div class="home">
        <!-- <div class="box"> -->
          <div class="word-container">
            <div :id="`word${index}`" class="word" v-for="(word, index) in showWordList.slice(0, 3)" :key="word.name">
              <img class="top" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/top.png"/>
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div> 
            </div>
          </div>
          <div class="word-container">
            <div :id="`word${index+3}`" class="word" v-for="(word, index) in showWordList.slice(3, 6)" :key="word.name">
              <img class="top" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/top.png"/>
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div> 
            </div>
          </div>
        <!-- </div>   -->
        
        <!-- <div class="word-container">
          <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :id="`word${index+6}`" class="word" v-for="(word, index) in showWordList.slice(6, 9)" :key="word.name">
            <img src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/anime/type0/0.png"/>
            <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :style="{backgroundImage: 'url(' + word.icon + ')'}"></div>
          </div>
        </div> -->
        <img id="person" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/walk/0.png">
        <img id="partner" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/clap/0.png">
        <!-- <img id="partner" src="@/assets/game3-2/clap/0.png"> -->
        <img class="logo" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/logo.png"/>
        <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
           <img @click="backHandler" class="back" src="@/assets/back.png"/>
           <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
           <img @click="startHandler" class="voice" src="@/assets/voice.png"/>
        </div>
        <!-- <div class="sound-box-bottom"> -->
           <!-- <img @click="backHandler" class="back" src="@/assets/back.png"/> -->
           <!-- <img @click="reverseHandler" class="reverse" src="@/assets/reverse.png"/> -->
           <!-- <img @click.stop.prevent="startHandler" class="voice" src="@/assets/voice.png"/> -->
        <!-- </div> -->
        <audio id="myAudio" preload="auto"></audio>
        <audio id="failAudio" preload="auto">
          <source :src="this.failAudio">
        </audio>
        <audio id="flyAudio" preload="auto">
          <source :src="this.flyAudio">
        </audio>
        <audio id="hecaiAudio" preload="auto">
          <source :src="this.hecaiAudio">
        </audio>
        <audio id="zhunbeiAudio" preload="auto">
          <source :src="this.zhunbeiAudio">
        </audio>
        
        <Overlay class="mask-dialog" :show="showStartGameIcon">
          <img class="overlay-bg" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/bg.png"/>
          <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
            <img @click="backHandler" class="back" src="@/assets/back.png"/>
            <!-- <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
            <img @click="startHandler" class="voice" src="@/assets/voice.png"/> -->
          </div>
          <div class="mask-title">{{index}} {{gameName}}</div>
          <img @click="startGameHandler(true)" class="start" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/btn-start.png"/>
        </Overlay>
      </div>
    <!-- </scaleWrap> -->
  </horizontalScreen>
</template>
<script>
import anime from 'animejs/lib/anime.es.js'
import horizontalScreen from '@/components/horizontal-screen'
// import scaleWrap from '@/components/scale-wrap'
import {shuffle, isEmpty, cloneDeep} from 'lodash'
import { Overlay } from 'vant'
import mixin from '../mixin'
import {Howl} from 'howler'
import {isIOS} from '@/utils/env'

export default {
  name: 'GameCourse',
  mixins: [mixin],
  components: {
    // , scaleWrap
    horizontalScreen, Overlay
  },
  created () {
    this.zhunbeiAudioVoice = new Howl({
      src: [this.zhunbeiAudio],
      html5: isIOS
    });
    this.hecaiAudioVoice = new Howl({
      src: [this.hecaiAudio],
      html5: isIOS
    });
    this.flyAudioVoice = new Howl({
      src: [this.flyAudio],
      html5: isIOS
    });
  },
  beforeDestroy () {
    this.zhunbeiAudioVoice.pause()
    this.hecaiAudioVoice.pause()
    this.flyAudioVoice.pause()
  },
  data() {
    return {
      zhunbeiAudioVoice: null,
      hecaiAudioVoice: null,
      flyAudioVoice: null,
      personTarget: {
        right: null,
        bottom: null
      },
      partnerTarget: {
        right: null,
        bottom: null
      },
      index: this.$route.query.index,
      id: this.$route.query.id,
      gameName: null,
      zhunbeiAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/sounds/zhunbei.mp3`,
      hecaiAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/sounds/zhuhe.mp3`,
      flyAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/sounds/tou.mp3`,
      clickAudio: require(`@/assets/sounds/click.mp3`),
      failAudio: require(`@/assets/sounds/fail.mp3`),
      clapImgLength: 15, // 小人拍手动画的图片张数35
      boardImgLength: 2, // 花苞
      workImgLength: 40, // 小人走路动画
      digImgLength: 105
    }
  },
  watch: {
    isWalk(val) {
      this.$nextTick(() => {
        const person = document.getElementById('person')
        if (val) {
          person.style.zIndex = 60
        } else {
          console.log('person.style.right', person.style.right, this.personTarget.right)
          if (!person.style.right || person.style.right.slice(0,-2) == this.personTarget.right) {
            person.style.zIndex = 40
          }
        }
      })
    }
  },
  mounted() {
    this.initPartnerLocation()
    this.initPersonLocation()
  },
  methods: {
    isEmpty,
    initPersonLocation(){
      const personTarget = document.getElementById('person')
      if (this.isVertical) {
        this.personTarget.bottom = document.body.clientWidth - personTarget.offsetTop - personTarget.offsetHeight
        this.personTarget.right = document.body.clientHeight - personTarget.offsetLeft - personTarget.offsetWidth
      } else {
        this.personTarget.bottom = document.body.clientHeight - personTarget.offsetTop - personTarget.offsetHeight
        this.personTarget.right = document.body.clientWidth - personTarget.offsetLeft - personTarget.offsetWidth
      }
    },
    initPartnerLocation(){
      const partnerTarget = document.getElementById('partner')
      if (this.isVertical) {
        this.partnerTarget.bottom = document.body.clientWidth - partnerTarget.offsetTop - partnerTarget.offsetHeight
        this.partnerTarget.right = document.body.clientHeight - partnerTarget.offsetLeft - partnerTarget.offsetWidth
      } else {
        this.partnerTarget.bottom = document.body.clientHeight - partnerTarget.offsetTop - partnerTarget.offsetHeight
        this.partnerTarget.right = document.body.clientWidth - partnerTarget.offsetLeft - partnerTarget.offsetWidth
      }
      console.log('partnerTarget', this.partnerTarget)
     
    },
    // 石头动画
    partnerClapGifHandler () {
      // document.getElementById('flyAudio').play()
      this.flyAudioVoice.play()
      clearInterval(this.timerSigh)
      let i = 0
      const partner = document.getElementById('partner')
      this.timerSigh = setInterval(() => {
        this.isWalk = true
        if (i >= this.clapImgLength - 1) {
          clearInterval(this.timerSigh)
          this.isWalk = false
          partner.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/clap/${0}.png`
        } else {
          i=i+1
          partner.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/clap/${i}.png`
        }
      }, 60)
    },
    // 走路动画
    personWalkGifHandler (id, index) {
      clearInterval(this.timerWalk)
      this.timerWalk = null
      let i = 0
      const person = document.getElementById('person')
      const partner = document.getElementById('partner')
      const target = document.getElementById(`${id}`)
      const flowerTarget = document.querySelector(`#${id} .flower`)

      this.timerWalk = setInterval(() => {
        this.isWalk = true
        // 前面17张走路
        if (i>=this.workImgLength) {
          clearInterval(this.timerWalk)
          this.timerWalk = null
          partner.style.visibility = 'visible'
          this.animation = anime({
            targets: partner,
            bottom: `${(this.isVertical ?  document.body.clientWidth : document.body.clientHeight) - target.offsetTop}px`,
            right: this.isVertical ? `${document.body.clientHeight - target.offsetLeft - target.offsetWidth/2 - partner.offsetWidth/2}px` : `${document.body.clientWidth - target.offsetLeft - target.offsetWidth/2 - partner.offsetWidth/2}px`,
            easing: 'easeInOutQuad',
            duration: (this.clapImgLength-5)*50, // 走路多久到达的时间 走路的动作乘以时间
            complete: () => {
              flowerTarget.style.zIndex = 100
              this.animation2 = anime({
                targets: partner,
                bottom: `${(this.isVertical ?  document.body.clientWidth : document.body.clientHeight) - target.offsetTop - partner.offsetHeight*2}px`,
                // right: this.isVertical ? `${document.body.clientHeight - target.offsetLeft - target.offsetWidth/2 - partner.offsetWidth/2}px` : `${document.body.clientWidth - target.offsetLeft - target.offsetWidth/2 - partner.offsetWidth/2}px`,
                easing: 'easeInOutQuad',
                duration: 5*50, // 走路多久到达的时间 走路的动作乘以时间
                complete: () => {
                  // target.innerHTML = '到达'
                  clearInterval(this.timerWalk)
                  partner.style.visibility = 'hidden'
                  target.style.zIndex = 40
                  flowerTarget.style.zIndex = 40
                  // document.getElementById('hecaiAudio').play()
                  this.hecaiAudioVoice.play()

                  this.personDigGifHandler(`${id}`, index)
                  
                }
              });
              
            }
          });
          this.partnerClapGifHandler()
          // this.isWalk = false
        } else {
          i=i+1
          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/walk/${i}.png`
        }
      }, 60)
    },
    // 挖宝动画
    personDigGifHandler (id, index) {
      clearInterval(this.timerDig)
      this.timerDig = null
      let i = this.workImgLength
      const person = document.getElementById('person')
      this.timerDig = setInterval(() => {
        this.isWalk = true
        if (i >= this.digImgLength -1) {

          clearInterval(this.timerDig)
          this.timerDig = null
          // this.isWalk = false
          // person.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/walk/${0}.png`
          this.boardGifHandler(`${id}`, index)
        } else {
          i=i+1
          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/walk/${i}.png`
        }
      }, 50)
    },
    // 面板动画
    boardGifHandler (id, index) {
      clearInterval(this.timerBoard)
      this.timerBoard = null
     
      const animeType = this.animeTypes
      let i = 0
      const wordTarget = document.querySelector(`#${id} div`)
      const partner = document.querySelector(`#partner`)
      const person = document.querySelector(`#person`)
      wordTarget.style.display = 'none'
      

      const target = document.querySelector(`#${id} .flower`)
      this.timerBoard = setInterval(() => {
        this.isWalk = true
        if (i>=this.boardImgLength-1) {
          clearInterval(this.timerBoard)
          this.timerBoard = null
          // 隐藏花
          // target.style.display = 'none'
          // word.style.visibility = 'hidden'

          // this.isWalk = false
          this.showWordList[index].clicked = false
          
          this.delayTimer = setTimeout(() => {
            person.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/walk/${0}.png`
            partner.style.left = null
            partner.style.top = null
            partner.style.bottom = `${this.partnerTarget.bottom}px`
            partner.style.right = `${this.partnerTarget.right}px`
            this.getData(true)
          }, 500)
          // 下一个字包括音效 
        } else {
          i=i+1
          target.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/anime/type${animeType}/${i}.png`
          // target.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/anime/type${animeType}/${i}.png`
        }
      }, 30)
    },
    // 打乱文字排序
    async reverseHandler() {
      if (!this.isWalk){
        clearInterval(this.timerWalk)
        this.timerWalk = null
        clearInterval(this.timerSigh)
        this.timerSigh = null
        clearInterval(this.timerClap)
        this.timerClap = null
        clearInterval(this.timerDig)
        this.timerDig = null
        clearInterval(this.timerBoard)
        this.timerBoard = null

        const partner = document.getElementById('partner')
        partner.style.left = null
        partner.style.top = null
        partner.style.bottom = `${this.partnerTarget.bottom}px`
        partner.style.right = `${this.partnerTarget.right}px`
        

        this.audioList = []
        await this.initData()
        
        this.showWordList = shuffle(this.InitWordList)
        this.wordList = cloneDeep(this.showWordList)
        this.$set(this, 'showWordList', shuffle(this.InitWordList)) 
        this.$set(this, 'wordList', cloneDeep(this.showWordList)) 
        for(let i =0;i<this.InitWordList.length;i++) {
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          const topTarget = document.querySelector(`#word${i} .top`)
          topTarget.style.display = 'none'
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.style.top = '0'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/anime/type0/${0}.png`
        }
         for(let i =0;i<this.showWordList.length;i++) {
          this.showWordList[i].clicked = false
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          const topTarget = document.querySelector(`#word${i} .top`)
          topTarget.style.display = 'none'
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.style.top = '0'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/anime/type0/${0}.png`
        }
        // 一切重新开始
        this.getData()
        this.startGameHandler()
      }
    },
    // 字点击
    wordClickHandler(event, word, index) {
      console.log('word', word, event.target.className)
      console.log('isWalk', this.isWalk)

      if (this.isWalk) return

      let parentNode = event.target.parentElement
      if (event.target.className == 'icon-img') {
        parentNode = event.target.parentElement.parentElement
      } else {
        parentNode = event.target.parentElement
      }
      anime({
        targets: parentNode,
        scale: [
          { value: 1, duration: 100 },
          { value: 1.1, duration: 100 },
          { value: 1, duration: 100 }
        ],
        complete: () => {
          parentNode.style.transform = 'none'
        }
      });
      
      if (this.currentWord.name !== word.name) {
        this.playClickAudio()
        this.playFailAudio()
        
        return false
      }

      this.showWordList[index].clicked = true

      this.playClickAudio()
      // document.getElementById('zhunbeiAudio').play()
      this.zhunbeiAudioVoice.play()

      // 文字消失
      const wordTarget = document.querySelector(`#word${index} div`)
      // 变换成第一个花苞
      const flowerTarget = document.querySelector(`#word${index} .flower`)

      const topTarget = document.querySelector(`#word${index} .top`)

      // 瞄准
      this.personWalkGifHandler(`word${index}`, index)

      wordTarget.style.display = 'none'
      topTarget.style.display = 'block'
      flowerTarget.style.top = '12%'
      flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/anime/type0/${1}.png`
     
      
    }
  }
}
</script>

<style lang="scss" scoped>
.v-game-course{
  // font-family: 'Alibaba-PuHuiTi-Bold';
  // font-family: 'FZHuPo-M04S';
audio {
  position: absolute;
  top: -1000px;
  left: -1000px;
  z-index: -1;
}
.mask-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  // background: url(~https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  .overlay-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: -1;
  }
   .mask-title {
    border: solid 3px #5f0001;
    color: #5f0001;
    font-size: 50px;
    padding: 20px 0;
    text-align: center;
    background: #fff;
    border-radius: 60px;
    width: 76%;
    margin: 5% auto;
  }
  .start {
    display: block;
    width: 124px;
  }
  .btn-restart {
    width: 223.33px;
  }
}

.home {
  height: 100%;
  width: 100%;
  background: url(https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-2/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;
}
.box {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
}
// .logo {
//   width: 12px;
//   left: 5px;
//   top: 10PX;
//   position: fixed;
// }
.sound-box-top {
  width: 46px;
  right: 20px;
  top: 10PX;
  z-index: 990;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.sound-box-bottom {
  z-index: 990;
  width: 46px;
  right: 5px;
  bottom: 5px;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.word-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  &:nth-of-type(1) {
    margin-left: 6%;
    height: 50%;
    margin-top: 20px;
    display: flex;
    align-items: flex-end;
  }
  &:nth-of-type(2) {
    margin-top: 20px;
    margin-left: 8%;
  }
  .word {
    transform-origin: center;
    width: 110px;
    height: 134.78px;
    font-size: 30px;
    // font-weight: bolder;
    position: relative; 

    .top {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
    }
    .flower {
      position: absolute; 
      width: 100%;
      // width: 319.5px;
      // height: 416.5px;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
    & + .word {
      margin-left: 40px;
    }
    
    .icon {
      z-index: 60;
      display: block;
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 4%;
    }
    .icon-img {
      z-index: 60;
      display: block;
      width: 74px;
      height: 74px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 44%;
    }
  }
}
#person {
  width: 300px;
  // height: 240.85px;
  position: fixed;
  right: -90px;
  bottom: 0px;
  z-index: 40;
}
#partner {
  width: 54px;
  height: 55.57px;
  position: fixed;
  right: 140px;
  bottom: 140px;
  visibility: hidden;
  z-index: 99;
}
}
</style>